<template>
  <div>
    <!-- 出入金变更申请： -->
    <el-dialog :title="$t('message.applyForDepositWithdrawalModification')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="552px" center>
      <div class="content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
          <!-- 客户信息 -->
          <el-form-item :label="$t('message.userInfo')" prop="user_id">
            <el-input v-model="ruleForm.user_id" style="width: 120px;" @blur="clientList"></el-input>
            <div class="name">{{ name }}</div>
          </el-form-item>
          <!-- 申请原因 -->
          <el-form-item :label="$t('message.reasonForApplication')" prop="adjust_reason">
            <el-input v-model="ruleForm.adjust_reason" type="textarea"></el-input>
          </el-form-item>
          <!-- 出入金类型： -->
          <el-form-item :label="$t('message.depositWithdrawalType')" prop="type">
            <el-select v-model="ruleForm.type" placeholder="请选择">
              <el-option v-for="item in typeOptions" :key="item.key" :label="item.value" :value="item.key">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 出入金金额 -->
          <el-form-item :label="$t('message.depositWithdrawalAmount') + '.円'" prop="amount">
            <el-input v-model="ruleForm.amount" @input="handleInputPrice"></el-input>
          </el-form-item>
          <!-- 出入金名义 -->
          <el-form-item :label="$t('message.depositWithdrawalName') + '（日文-客户看）'" prop="client_bill_reason">
            <el-input v-model="ruleForm.client_bill_reason" type="textarea"></el-input>
          </el-form-item>
          <!-- 附带图片 -->
          <el-form-item :label="$t('message.withAttachedImages')">
            <div class="imgList">
              <div class="item" v-for="(item, index) in ruleForm.image" :key="index">
                <el-image style="width: 100px;height: 100px;border-radius: 6px; margin-right: 12px;" :src="item"
                  :preview-src-list="[item]">
                </el-image>
                <i class="el-icon-circle-close" @click="ruleForm.image.splice(index, 1)"></i>
              </div>
              <el-upload action="https://jsonplaceholder.typicode.com/posts/" list-type="picture-card" multiple drag
                :http-request="httpupimgList" :show-file-list="false">
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 取消 -->
        <el-button @click="dialogVisible = false">{{ $t('message.cancel') }}</el-button>
        <!-- 提交申请 -->
        <el-button type="primary" @click="adjustApplicationCreate">{{ $t('message.submitApplication') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="imgDialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      imgDialogVisible: false,
      dialogImageUrl: '',
      ruleForm: {
        image: []
      },
      rules: {
        user_id: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        adjust_reason: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        amount: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        client_bill_reason: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],

      },
      name: '',
      typeOptions: [],
    };
  },
  created() {
    this.$api.financialApi.adjustApplicationTypeOptions().then(res => {
      this.typeOptions = res.data
    })
  },
  methods: {
    // 客户名
    clientList() {
      if (this.ruleForm.user_id) {
        this.$api.JapaneseOffice.clientInfo({ user_id: this.ruleForm.user_id }).then(res => {
          this.name = res.data.realname
          this.$forceUpdate()
        })
      }
    },
    // 不能输入负数
    handleInputPrice() {
      this.ruleForm.amount = ("" + this.ruleForm.amount) // 第一步：转成字符串
        .replace(/[^0-9]/g, '') // 第二步：把不是数字过滤
      this.$forceUpdate()
    },
    //提交申请
    adjustApplicationCreate() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$api.financialApi.adjustApplicationCreate(this.ruleForm).then(res => {
            this.$message.success(res.msg)
            this.dialogVisible = false
            this.$parent.adjustApplicationListTab()
            this.$parent.adjustApplicationList()
          })
        }
      })
    },
    // 上传
    async httpupimgList(file) {
      if (this.ruleForm.image.length >= 6) return this.$message.error('最多上传6张图片')
      let data = await this.createClient(file)
      this.ruleForm.image.push(data.data)
      this.$forceUpdate()
    },

  }
}
</script>
<style lang='scss' scoped>
.content {
  margin: 0 20px;
  font-size: 16px;

  /deep/.el-select {
    width: 100%;
  }

  /deep/.el-textarea__inner {
    height: 100px !important;
  }

  .imgList {
    display: flex;
    flex-wrap: wrap;

    .item {
      position: relative;

      .el-icon-circle-close {
        position: absolute;
        top: -10px;
        right: 5px;
        font-size: 20px;
        cursor: pointer;
        z-index: 9;
        color: #B4272D;

      }
    }

    /deep/.el-upload {
      width: 100px;
      height: 100px;
    }

    /deep/.el-upload-dragger {
      width: 98px;
      height: 98px;
      border: none;
    }
  }
}
</style>